import { render, staticRenderFns } from "./SaGradientRoundedBox.vue?vue&type=template&id=31750ce7&"
import script from "./SaGradientRoundedBox.vue?vue&type=script&lang=js&"
export * from "./SaGradientRoundedBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports